export default {
    common: {
        active: 'Active',
        inactive: 'Inactive',
        select: 'Select…',
        save: 'Save',
        cancel: 'Cancel',
        edit: 'Edit',
        delete: 'Delete',
        loading: 'Loading…'
    },
    PhoneInput: {
        selectCountryCode: 'Ländercode',
        placeholder: 'Telefonnummer eingeben'
    },
    Settings: {
        General: {
            logoHint: 'Bitte ein quadratisches Logo hochladen (z. B. 256x256 oder 512x512).',
            logoPreview: 'Logo-Vorschau',
            logoUploading: 'Logo wird hochgeladen...',
            logoUploaded: 'Logo hochgeladen.',
            logoUploadError: 'Logo-Upload fehlgeschlagen.',
            logoUploadCta: 'Logo ändern',
            notificationEmail: 'Benachrichtigungs-E-Mail',
            notificationEmailPlaceholder: 'Benachrichtigungs-E-Mail eingeben',
            address: 'Adresse',
            addressPlaceholder: 'Adresse eingeben',
            country: 'Land',
            selectCountry: 'Land auswählen',
            phone: 'Telefon',
            phonePlaceholder: 'Telefonnummer eingeben',
            phoneCountry: 'Telefon-Land',
            website: 'Website',
            websitePlaceholder: 'Website eingeben',
            email: 'Firmen-E-Mail',
            emailPlaceholder: 'Firmen-E-Mail eingeben'
        },
        Billing: {
            billingEmail: 'Abrechnungs-E-Mail',
            billingEmailPlaceholder: 'Abrechnungs-E-Mail eingeben',
            saveBillingEmail: 'Abrechnungs-E-Mail speichern',
            billingEmailSaved: 'Abrechnungs-E-Mail gespeichert.',
            billingEmailError: 'Abrechnungs-E-Mail konnte nicht gespeichert werden',
            enterCard: 'Karte hinzufügen, um die Abrechnung zu aktivieren.',
            loadingPaymentForm: 'Zahlungsformular wird geladen...',
            missingPublishableKey: 'Stripe-Public-Key fehlt.',
            saveCard: 'Karte speichern',
            savingCard: 'Speichern...',
            cardSaved: 'Karte erfolgreich gespeichert.',
            cardError: 'Karte konnte nicht gespeichert werden',
            setupIntentError: 'Karteneinrichtung konnte nicht gestartet werden'
        }
    },
    Dashboard: {
        title: 'Dashboard',
        loading: 'Laden...',
        error: 'Fehler beim Laden der Dashboard-Daten',
        setup_title: 'Vervollständige die Firmeneinrichtung',
        setup_upload_logo_title: 'Firmenlogo hochladen',
        setup_upload_logo_desc: 'Füge ein Logo hinzu, damit deine Marke überall sichtbar ist.',
        setup_upload_logo_cta: 'Logo hinzufügen',
        setup_add_description_title: 'Firmenbeschreibung hinzufügen',
        setup_add_description_desc: 'Beschreibe kurz, was dein Unternehmen macht.',
        setup_add_description_cta: 'Beschreibung hinzufügen',
        setup_add_address_title: 'Firmenadresse vervollständigen',
        setup_add_address_desc: 'Füge Standort- und Länderdetails hinzu.',
        setup_add_address_cta: 'Adresse hinzufügen',
        setup_add_contact_title: 'Kontaktdaten hinzufügen',
        setup_add_contact_desc: 'E-Mail und Telefonnummer für Support und Abrechnung hinterlegen.',
        setup_add_contact_cta: 'Kontakte hinzufügen',
        setup_add_website_title: 'Unternehmenswebsite hinzufügen',
        setup_add_website_desc: 'Teile deine offizielle Website mit Kunden und Partnern.',
        setup_add_website_cta: 'Website hinzufügen',
        setup_set_localization_title: 'Lokalisierung festlegen',
        setup_set_localization_desc: 'Wähle Währung, Zeitzone und Sprache für Berichte.',
        setup_set_localization_cta: 'Lokalisierung festlegen',
        setup_add_billing_email_title: 'Abrechnungs-E-Mail hinzufügen',
        setup_add_billing_email_desc: 'Stelle sicher, dass Rechnungen die richtige Inbox erreichen.',
        setup_add_billing_email_cta: 'Abrechnungs-E-Mail hinzufügen',
        setup_add_venue_title: 'Erste Niederlassung anlegen',
        setup_add_venue_desc: 'Lege einen Standort an, damit du Produkte importieren kannst.',
        setup_add_venue_cta: 'Standort erstellen',
        setup_loyalty_points_title: 'Treuepunkte festlegen',
        setup_loyalty_points_desc: 'Lege fest, wie viele Punkte Kunden pro Kauf erhalten.',
        setup_loyalty_points_cta: 'Punkte konfigurieren',
        average_revenue_per_user: 'Durchschnittlicher Umsatz pro Nutzer',
        average_selling_transaction_value: 'Ø Verkaufstransaktionswert',
        belonging_users_count: 'Zugehörige Nutzer',
        campaigns_count: 'Kampagnen',
        manufacturer_count: 'Hersteller',
        revenue_value: 'Umsatz',
        selling_transactions_count: 'Verkaufstransaktionen',
        sold_items_count: 'Verkaufte Artikel',
        total_transaction_volume: 'Gesamtes Transaktionsvolumen',
        users_count: 'Nutzer',
        venues_count: 'Standorte'
    },
    LoginPage: {
        title: 'Willkommen zurück',
        subtitle: 'Zugang zu Garantien, Loyalty und Analysen mit einem Login.',
        email_label: 'E-Mail',
        password_label: 'Passwort',
        login_button: 'Anmelden',
        login_error: 'Login fehlgeschlagen. E-Mail und Passwort prüfen.',
        register: 'Registrieren',
        no_account: 'Noch kein Konto?',
        forgot_password: 'Passwort vergessen'
    },
    RegisterPage: {
        title: 'Firma registrieren',
        subtitle: 'Erstelle dein Unternehmenskonto in wenigen Minuten.',
        company_name: 'Firmenname',
        company_type: 'Firmentyp',
        currency: 'Währung',
        select_type: 'Typ auswählen',
        select_currency: 'Währung auswählen',
        select_required: 'Bitte wähle Firmentyp und Währung aus.',
        admin_name: 'Admin-Name',
        admin_surname: 'Admin-Nachname',
        admin_email: 'Admin-E-Mail',
        password: 'Passwort',
        password_repeat: 'Passwort wiederholen',
                field_required: 'Dieses Feld ist erforderlich.',
        fix_required: 'Bitte alle Pflichtfelder ausfüllen.',
        passwords_mismatch: 'Passwörter stimmen nicht überein.',
        registration_failed: 'Registrierung fehlgeschlagen. Bitte prüfe das Formular und versuche es erneut.',
        submit: 'Registrieren',
        registering: 'Registriere...',
        back_to_login: 'Zurück zur Anmeldung'
    },
    DistributorRetailers: {
        title: 'Retail partners',
        subtitle: 'Understand which retailers rely on you for each brand/category.',
        loading: 'Loading retailers...',
        error: 'Unable to load retailers.',
        searchPlaceholder: 'Search retailers…',
        list: {
            title: 'Retailer overview'
        },
        tabs: {
            list: 'Overview',
            graph: 'Timeline'
        },
        stats: {
            totalRetailers: 'Total retailers',
            outboundValue: 'Outbound value',
            outboundQuantity: 'Outbound units'
        },
        table: {
            title: 'Retailers',
            count: '{{count}} total',
            retailer: 'Retailer',
            manufacturers: 'Manufacturers',
            outbound: 'Outbound',
            categories: 'Categories',
            units: '{{count}} units',
            allCategories: 'All categories',
            view: 'View'
        },
        pagination: {
            prev: 'Prev',
            next: 'Next'
        },
        graph: {
            period: 'Period',
            retailers: 'Retailers',
            allRetailers: 'All retailers',
            noData: 'No timeline data yet.',
            error: 'Unable to load timeline data.',
            periodOption: {
                yesterday: 'Yesterday',
                last_7_days: 'Last 7 days',
                this_month: 'This month',
                this_quarter: 'This quarter',
                this_year: 'This year'
            }
        }
    },
    DistributorRetailerDetail: {
        loading: 'Loading retailer detail…',
        error: 'Unable to load retailer detail.',
        subtitle: 'No description provided',
        back: 'Back to retailers',
        metrics: {
            outboundValue: 'Outbound value',
            outboundQuantity: 'Outbound units',
            manufacturers: 'Linked manufacturers'
        },
        manufacturers: 'Manufacturers & categories',
        recentOrders: 'Recent orders',
        empty: 'No data yet.'
    },
    DistributorManufacturers: {
        title: 'Partner manufacturers',
        subtitle: 'Monitor connected brands, inbound supply, and sell-through performance.',
        loading: 'Loading manufacturers...',
        error: 'Unable to load manufacturers.',
        searchPlaceholder: 'Search manufacturers…',
        stats: {
            totalManufacturers: 'Total linked manufacturers',
            inboundValue: 'Inbound value',
            outboundValue: 'Outbound value'
        },
        table: {
            title: 'Manufacturers',
            count: '{{count}} total',
            manufacturer: 'Manufacturer',
            inbound: 'Inbound',
            outbound: 'Outbound',
            retailers: 'Active retailers',
            units: '{{count}} units',
            view: 'View'
        },
        periodOption: {
            last_7_days: 'Last 7 days',
            this_month: 'This month',
            this_quarter: 'This quarter',
            this_year: 'This year'
        },
        list: {
            title: 'Manufacturer overview'
        },
        pagination: {
            prev: 'Prev',
            next: 'Next'
        }
    },
    DistributorManufacturerDetail: {
        loading: 'Loading manufacturer detail…',
        error: 'Unable to load manufacturer detail.',
        subtitle: 'No description provided',
        back: 'Back to manufacturers',
        metrics: {
            inboundValue: 'Inbound value',
            inboundQuantity: 'Inbound units',
            outboundValue: 'Outbound value',
            outboundQuantity: 'Outbound units',
            activeRetailers: 'Active retailers'
        },
        topRetailers: 'Top retailers',
        recentActivity: 'Recent activity',
        empty: 'No data yet.',
        activity: {
            outbound: 'Outbound',
            inbound: 'Inbound'
        }
    },
    login: "Anmelden",
    email: "E-Mail",
    password: "Passwort",
    submit: "Einreichen",
    error: "Ungültige E-Mail oder Passwort.",
    ManufacturerNav: {
        dashboard: 'Dashboard',
        products: 'Produkte',
        retailers: 'Händler',
        distributors: 'Distributoren',
        venues: 'Venues',
        transactions: 'Transactions',
        warranties: 'Warranties',
        support: 'Support',
        integrations: 'Integrationen',
        imports: 'Importe/Exporte',
        compliance: 'Compliance',
        settings: 'Einstellungen',
        logout: 'Abmelden'
    },
    ManufacturerTransactions: {
        title: 'Transactions',
        subtitle: 'Analyze sell-in vs sell-through across retailers, venues, and SKUs.',
        tabs: {
            overview: 'Overview',
            statistics: 'Statistics',
            progress: 'Progress'
        },
        cards: {
            sellIn: 'Sell-in value',
            sellThrough: 'Sell-through value',
            retailers: 'Retail partners',
            venues: 'Active venues',
            buyers: 'Distinct buyers',
            transactions: 'Transactions',
            units: '{{count}} units'
        },
        table: {
            columns: {
                date: 'Date',
                retailer: 'Retailer',
                venue: 'Venue',
                sellInValue: 'Sell-in value',
                sellThroughValue: 'Sell-through value',
                transactions: 'Transactions'
            }
        },
        statistics: {
            gender: 'Buyer gender distribution',
            age: 'Buyer age groups',
            countries: 'Buyer countries',
            venues: 'Venue contribution',
            buyers: 'Buyers'
        },
        progress: {
            sellThrough: 'Sell-through comparison',
            current: 'Current period',
            previous: 'Previous period'
        },
        errors: {
            loadStats: 'Unable to load transactions.',
            loadDemographics: 'Unable to load statistics.',
            loadProgress: 'Unable to load progress data.'
        }
    },
    ManufacturerDashboard: {
        title: 'Hersteller-Dashboard',
        loading: 'Lade Herstellerstatistiken...',
        error: 'Hersteller-Dashboard konnte nicht geladen werden.',
        totalSkus: 'Gesamt-SKUs',
        activeDistributors: 'Aktive Distributoren',
        sellThrough: 'Sell-Through-Wert',
        sellIn: 'Sell-In-Wert',
        activeRetailers: 'Aktive Händler',
        returns: 'Rückgaben',
        activeWarranties: 'Aktive Garantien',
        campaignsRunning: 'Laufende Kampagnen',
        avgSellThrough: 'Durchschnittlicher Sell-Through-Wert',
        sellThroughRate: 'Sell-Through-Rate',
        sellInQuantity: 'Sell-In-Einheiten',
        sellThroughQuantity: 'Sell-Through-Einheiten',
        sellInTransactions: 'Sell-In-Transaktionen',
        sellThroughTransactions: 'Sell-Through-Transaktionen',
        uniqueBuyers: 'Einzigartige Käufer',
        warrantyActivation: 'Garantieaktivierungsrate',
        openTickets: 'Offene Service-Tickets',
        returnsRate: 'Rücklaufquote',
        avgTtr: 'Durchschnittliche Reparaturzeit',
        topSkus: 'Top-SKUs',
        topRetailers: 'Top-Händler',
        topUserRegions: 'Top-Nutzer-Regionen',
        topRetailerRegions: 'Top-Händler-Regionen',
        topBuyers: 'Top-Käufer',
        actions: 'Empfohlene Aktionen',
        noActions: 'Keine sofortigen Aktionen erforderlich.'
    },
    ManufacturerProducts: {
        title: 'Produktkatalog',
        subtitle: 'Verwalten Sie Ihre SKUs und verfolgen Sie Sell-In/Sell-Through.',
        tabs: {
            catalog: 'Katalog',
            transactions: 'Transaktionen'
        },
        searchPlaceholder: 'Nach SKU oder Name suchen...',
        newProduct: 'Neues Produkt',
        table: {
            columns: {
                product: 'Produkt',
                sku: 'SKU',
                sellIn: 'Sell-In-Einheiten',
                sellThrough: 'Sell-Through-Einheiten',
                sellThroughValue: 'Sell-Through-Wert',
                actions: 'Aktionen'
            },
            view: 'Anzeigen'
        },
        create: {
            title: 'Produkt anlegen',
            fields: {
                product_name: 'Produktname',
                model_number: 'Modellnummer',
                description: 'Beschreibung',
                release_year: 'Erscheinungsjahr',
                warranty_duration: 'Garantie (Monate)',
                warranty_coverage: 'Garantieumfang',
                documentation_url: 'Dokumentations-URL',
                initial_price: 'Startpreis (€)'
            },
            cancel: 'Abbrechen',
            save: 'Speichern',
            saving: 'Speichern...'
        },
        notifications: {
            created: 'Produkt erfolgreich erstellt.'
        },
        transactions: {
            title: 'Hersteller-Transaktionen',
            subtitle: 'Sell-In und Sell-Through nach Zeitraum.',
            retailers: 'Händler',
            customers: 'Kunden'
        },
        detail: {
            back: 'Zurück zu Produkten',
            cards: {
                sellInUnits: 'Sell-In-Einheiten',
                sellInValue: 'Sell-In-Wert',
                sellThroughUnits: 'Sell-Through-Einheiten',
                sellThroughValue: 'Sell-Through-Wert'
            },
            insights: 'Verkaufs-Insights',
            sellInSeries: 'Sell-In Menge',
            sellThroughSeries: 'Sell-Through Menge',
            topRetailers: 'Top-Händler',
            topUserRegions: 'Top-Kundenregionen',
            topRetailerRegions: 'Top-Händlerregionen',
            topBuyers: 'Top-Käufer',
            transactions: 'Transaktionsübersicht',
            periodNote: 'Gefiltert nach Zeitraum',
            transactions_retailers: 'Händler',
            transactions_distributors: 'Distributoren',
            transactions_customers: 'Kunden',
            units: '{{count}} Einheiten',
            noTransactions: 'Keine Transaktionen in diesem Zeitraum.',
            variants: 'Varianten',
            variantModel: 'Modell',
            variantSku: 'SKU',
            variantAttributes: 'Attribute',
            noVariants: 'Keine Varianten vorhanden.',
            identifiers: 'Kennungen',
            identifierType: 'Typ',
            identifierValue: 'Wert',
            identifierSku: 'SKU',
            noIdentifiers: 'Keine Kennungen vorhanden.'
        },
        errors: {
            fetchFailed: 'Produkte konnten nicht geladen werden.',
            createFailed: 'Produkt konnte nicht erstellt werden.'
        }
    },
    ManufacturerRetailers: {
        title: 'Retail partners',
        subtitle: 'Monitor who buys from you, how they perform, and drill into transaction trends.',
        tabs: {
            list: 'Retailers',
            graph: 'Retailers Graph',
            venues: 'Venues'
        },
        table: {
            search: 'Search retailers...',
            view: 'Open',
            columns: {
                retailer: 'Retailer',
                inventory: 'Units in stock',
                sold: 'Units sold',
                sellInValue: 'Buy value',
                sellThroughValue: 'Sell value',
                venues: 'Venues',
                action: 'Action'
            }
        },
        graph: {
            period: 'Period',
            retailers: 'Retailers',
            allRetailers: 'All retailers',
            noData: 'No activity recorded for the selected filters.',
            buyLabel: 'Retailers Buy',
            sellLabel: 'Retailers Sell',
            periodOption: {
                yesterday: 'Yesterday',
                last_7_days: 'Last 7 days',
                this_month: 'This Month',
                this_quarter: 'This Quarter',
                this_year: 'This Year'
            }
        },
        errors: {
            loadList: 'Unable to load retailers.',
            loadGraph: 'Unable to load graph data.'
        },
        venues: {
            search: 'Search venues or retailers...',
            columns: {
                venue: 'Venue',
                retailer: 'Retailer',
                location: 'Location',
                sellThroughValue: 'Sell-through value',
                lastActivity: 'Last activity'
            },
            errors: {
                loadList: 'Unable to load retailer venues.'
            }
        }
    },
    ManufacturerDistributors: {
        title: 'Distributoren',
        subtitle: 'Überwachen Sie Upstream-Partner, Abdeckung und Kanal-Performance.',
        tabs: {
            list: 'Liste',
            stats: 'Analysen'
        },
        table: {
            search: 'Distributoren suchen...',
            view: 'Öffnen',
            notAvailable: 'k.A.',
            columns: {
                distributor: 'Distributor',
                country: 'Land',
                inventory: 'Einheiten im Kanal',
                sold: 'Verkaufte Einheiten',
                inbound: 'Eingehender Wert',
                outbound: 'Ausgehender Wert',
                venues: 'Standorte',
                action: 'Aktion'
            }
        },
        stats: {
            loading: 'Vertriebs-Analysen werden geladen...',
            error: 'Analysen konnten nicht geladen werden.',
            cards: {
                distributors: 'Aktive Distributoren',
                inventory: 'Einheiten im Kanal',
                sold: 'Verkaufte Einheiten',
                inbound: 'Eingehender Wert',
                outbound: 'Ausgehender Wert',
                venues: 'Verknüpfte Standorte'
            },
            trend: {
                title: 'Werttrend (EUR)',
                inbound: 'Eingehend',
                outbound: 'Ausgehend',
                empty: 'Diese Woche keine Bewegungen.'
            },
            countries: {
                title: 'Top-Länder',
                empty: 'Keine Länder vorhanden.'
            }
        },
        errors: {
            loadList: 'Distributoren konnten nicht geladen werden.',
            loadStats: 'Analysen konnten nicht geladen werden.'
        }
    },
    ManufacturerRetailerDetail: {
        back: 'Back to Retailers',
        subtitle: 'Full visibility into this retailer relationship.',
        loading: 'Loading retailer detail...',
        error: 'Unable to load retailer detail.',
        stats: {
            inventory: 'Units in stock',
            sold: 'Units sold',
            buyValue: 'Buy value',
            sellValue: 'Sell value',
            units: 'units'
        },
        contact: {
            title: 'Contacts & HQ',
            notAvailable: 'Not provided'
        },
        venues: {
            title: 'Venues',
            empty: 'No venues connected.'
        },
        items: {
            title: 'Manufacturer items performance',
            empty: 'No transactions recorded for this retailer.',
            columns: {
                product: 'Product',
                sku: 'SKU',
                purchased: 'Purchased',
                sold: 'Sold'
            }
        }
    },
    ManufacturerDistributorDetail: {
        back: 'Zurück zu den Distributoren',
        subtitle: 'Komplette Sicht auf diese Distributor-Beziehung.',
        loading: 'Distributor wird geladen...',
        error: 'Distributor konnte nicht geladen werden.',
        stats: {
            inventory: 'Einheiten im Kanal',
            sold: 'Verkaufte Einheiten',
            inbound: 'Einkäufe vom Hersteller',
            outbound: 'Verkäufe an Partner',
            venues: 'Standorte',
            units: 'Einheiten'
        },
        contact: {
            title: 'Kontaktinformationen',
            notAvailable: 'Nicht verfügbar'
        },
        venues: {
            title: 'Standorte',
            empty: 'Keine Standorte zugeordnet.'
        },
        activity: {
            title: 'Aktuelle Aktivität',
            empty: 'Keine aktuellen Transaktionen.',
            columns: {
                date: 'Datum',
                direction: 'Richtung',
                quantity: 'Menge',
                value: 'Wert'
            },
            direction: {
                inbound: 'Eingehend vom Hersteller',
                outbound: 'Ausgehend an Partner'
            }
        }
    },
    ManufacturerSettings: {
        title: 'Hersteller-Einstellungen',
        subtitle: 'Definieren Sie Eskalation, SLAs, Branding und API-Zugriff.',
        loading: 'Einstellungen werden geladen...',
        error: 'Einstellungen konnten nicht geladen werden.',
        escalation: {
            title: 'Eskalationsrichtlinie & SLA',
            subtitle: 'Bestimmen Sie Ansprechpartner und zugesagte Reaktionszeiten.',
            policy: 'Eskalationsrichtlinie',
            sla: 'Ziel-SLA (Stunden)',
            slaPlaceholder: 'z. B. 24',
            contacts: 'Eskalationskontakte',
            contactName: 'Name',
            contactEmail: 'E-Mail',
            contactPhone: 'Telefon'
        },
        branding: {
            title: 'Branding & Support',
            subtitle: 'Farben und Supportkanäle anpassen.',
            primary: 'Primärfarbe',
            secondary: 'Sekundärfarbe',
            logo: 'Logo-URL',
            supportEmail: 'Support-E-Mail',
            supportPhone: 'Support-Telefon'
        },
        api: {
            title: 'API-Tokens',
            subtitle: 'REST-Zugangsdaten für Integrationen verwalten.',
            key: 'Aktueller API-Key',
            secret: 'Neuer API-Secret (jetzt kopieren)',
            none: 'Nicht vorhanden',
            active: 'API aktiviert'
        },
        actions: {
            addContact: 'Kontakt hinzufügen',
            remove: 'Entfernen',
            rotateToken: 'Token rotieren',
            save: 'Einstellungen speichern',
            saving: 'Speichern...',
            add: 'Hinzufügen'
        },
        toast: {
            saved: 'Einstellungen gespeichert',
            error: 'Einstellungen konnten nicht gespeichert werden',
            token: 'Neues API-Token generiert'
        }
    },
    ManufacturerIntegrations: {
        title: 'Integrationen',
        subtitle: 'Verbinden Sie ERP/POS/CRM-Systeme und überwachen Sie Webhooks & Zugangsdaten.',
        loading: 'Lade Integrationen...',
        error: 'Integrationen konnten nicht geladen werden.',
        stats: {
            total: 'Anschlüsse gesamt',
            active: 'Aktiv',
            webhook: 'Webhook-Warnungen'
        },
        table: {
            name: 'Connector',
            type: 'Typ',
            status: 'Status',
            lastSync: 'Letzte Synchronisation',
            webhook: 'Webhook',
            actions: 'Aktionen',
            never: 'Nie'
        },
        status: {
            healthy: 'OK',
            warning: 'Warnung',
            stale: 'Veraltet',
            inactive: 'Inaktiv'
        },
        webhook: {
            healthy: 'OK',
            stale: 'Veraltet',
            missing: 'Fehlt',
            failing: 'Fehler',
            unknown: 'Unbekannt'
        },
        detail: {
            type: 'Connector-Typ',
            endpoint: 'API-Endpunkt',
            sync: 'Synchronisation',
            apiKey: 'API-Key',
            apiSecret: 'API-Secret (sofort kopieren)',
            webhookUrl: 'Webhook-URL',
            webhookSecret: 'Webhook-Secret'
        },
        form: {
            name: 'Name',
            type: 'Typ',
            email: 'Kontakt-E-Mail',
            endpoint: 'Endpoint URL',
            sync: 'Synchronisation',
            syncRealtime: 'Echtzeit',
            syncHourly: 'Stündlich',
            syncDaily: 'Täglich',
            webhook: 'Webhook-URL',
            isActive: 'Integration aktiv',
            custom: 'Custom'
        },
        actions: {
            add: 'Connector hinzufügen',
            cancel: 'Abbrechen',
            save: 'Speichern',
            saving: 'Speichern...',
            confirmDelete: 'Diesen Connector entfernen?',
            testWebhook: 'Webhook testen'
        },
        toast: {
            created: 'Connector erstellt',
            updated: 'Connector aktualisiert',
            deleted: 'Connector gelöscht',
            error: 'Aktion fehlgeschlagen',
            token: 'API-Zugangsdaten gedreht',
            webhook: 'Webhook-Test vermerkt',
            secret: 'API-Secret nur einmal sichtbar – jetzt kopieren'
        },
        editTitle: 'Connector bearbeiten',
        addTitle: 'Connector hinzufügen'
    },
    ManufacturerImportExport: {
        title: 'Importe & Exporte',
        subtitle: 'Verwalten Sie SKU-Kataloge, Garantien und Distributoren-Mappings.',
        loading: 'Lade Jobs...',
        error: 'Import/Export-Jobs konnten nicht geladen werden.',
        tabs: {
            imports: 'Importe',
            exports: 'Exporte',
        },
        types: {
            sku: 'SKU-Katalog',
            warranty: 'Garantievorlagen',
            distributor: 'Distributoren-Mappings',
        },
        form: {
            type: 'Typ',
            sourceName: 'Quellenname',
            sourceUrl: 'Quellen-URL',
            fileName: 'Dateiname (optional)',
        },
        imports: {
            requestTitle: 'Import starten',
            requestSubtitle: 'Laden Sie CSV/JSON über einen sicheren Link hoch.',
        },
        exports: {
            requestTitle: 'Export anfordern',
            requestSubtitle: 'Generieren Sie Dateien für nachgelagerte Systeme.',
        },
        actions: {
            startImport: 'Import einreihen',
            startExport: 'Export einreihen',
            submitting: 'Wird gesendet...',
        },
        table: {
            type: 'Typ',
            source: 'Quelle',
            status: 'Status',
            progress: 'Fortschritt',
            date: 'Datum',
            file: 'Datei',
            download: 'Download',
        },
        status: {
            pending: 'Ausstehend',
            processing: 'Verarbeitung',
            completed: 'Abgeschlossen',
            failed: 'Fehlgeschlagen',
        },
        history: {
            imports: 'Importverlauf',
            exports: 'Exportverlauf',
        },
        toast: {
            importCreated: 'Import wurde eingereiht',
            exportCreated: 'Export angefordert',
            error: 'Aktion fehlgeschlagen',
        },
    },
    ManufacturerCompliance: {
        title: 'Compliance & Zertifikate',
        subtitle: 'Verwalten Sie DPP, regulatorische Dokumente und ablaufende Zertifikate.',
        loading: 'Lade Dokumente...',
        error: 'Dokumente konnten nicht geladen werden.',
        types: {
            dpp: 'DPP',
            regulatory: 'Regulatorisch',
            certificate: 'Zertifikat',
        },
        form: {
            type: 'Dokumenttyp',
            title: 'Titel',
            description: 'Beschreibung',
            file: 'Datei-URL',
            expires: 'Ablaufdatum',
        },
        table: {
            doc: 'Dokument',
            type: 'Typ',
            expires: 'Läuft ab',
            status: 'Status',
            actions: 'Aktionen',
        },
        status: {
            draft: 'Entwurf',
            shared: 'Geteilt',
        },
        alerts: {
            expiring: '{{count}} Dokument(e) laufen in 30 Tagen ab',
        },
        actions: {
            add: 'Dokument hinzufügen',
            save: 'Speichern',
            saving: 'Speichern...',
            cancel: 'Abbrechen',
            edit: 'Bearbeiten',
            share: 'Teilen',
            confirmDelete: 'Dokument löschen?',
        },
        share: {
            title: 'Dokument teilen',
            description: 'E-Mail-Adressen durch Komma trennen.',
            placeholder: 'partner@example.com',
        },
        toast: {
            created: 'Dokument erstellt',
            updated: 'Dokument aktualisiert',
            deleted: 'Dokument gelöscht',
            shared: 'Dokument geteilt',
            error: 'Aktion fehlgeschlagen',
        },
    },
    ManufacturerVenues: {
        title: 'Manufacturer Venues',
        subtitle: 'Manage your own venue footprint and monitor sell-through per location.',
        table: {
            search: 'Search venues...',
            view: 'Open',
            columns: {
                venue: 'Venue',
                location: 'Location',
                sellThroughValue: 'Sell-through value',
                lastActivity: 'Last activity',
                action: 'Action'
            }
        },
        errors: {
            loadList: 'Unable to load venues.'
        },
        create: {
            button: 'New Venue',
            title: 'Add Venue',
            fields: {
                name: 'Venue name',
                city: 'City',
                address: 'Address',
                email: 'Email',
                phone: 'Phone',
                website: 'Website',
                description: 'Description'
            },
            cancel: 'Cancel',
            save: 'Create Venue',
            saving: 'Saving...',
            success: 'Venue created successfully.',
            error: 'Unable to create venue.',
            errors: {
                nameRequired: 'Name is required.'
            }
        }
    },
    ManufacturerVenueDetail: {
        back: 'Back to Venues',
        subtitle: 'Performance overview for {{city}} showroom',
        loading: 'Loading venue detail...',
        error: 'Unable to load venue detail.',
        stats: {
            sellIn: 'Sell-in value',
            sellThrough: 'Sell-through value',
            units: 'units'
        },
        contact: {
            title: 'Contact & location'
        },
        lastActivity: 'Last activity: {{date}}',
        topItems: {
            title: 'Top items',
            empty: 'No items sold yet.',
            metrics: '{{sell}} units • {{value}}'
        }
    },
    ManufacturerWarranties: {
        title: 'Warranties',
        subtitle: 'Define warranty templates and track active coverage for your products.',
        stats: {
            templates: 'Templates',
            active: 'Active warranties',
            expiring: 'Expiring (30d)'
        },
        tabs: {
            templates: 'Templates',
            active: 'Active warranties'
        },
        table: {
            template: 'Template',
            duration: 'Duration',
            type: 'Type',
            status: 'Status',
            actions: 'Actions',
            months: 'months',
            searchPlaceholder: 'Search templates...'
        },
        actions: {
            newTemplate: 'New template'
        },
        modal: {
            createTitle: 'Create warranty template',
            editTitle: 'Edit warranty template',
            fields: {
                name: 'Name',
                duration: 'Duration (months)',
                type: 'Template type',
                category: 'Category',
                item: 'Specific SKU',
                anyItem: 'Any item',
                description: 'Description',
                terms: 'Terms (one per line)',
                claimProcess: 'Claim process (one per line)',
                active: 'Active'
            }
        },
        active: {
            item: 'Item',
            serial: 'Serial',
            buyer: 'Buyer',
            activated: 'Activated',
            expires: 'Expires'
        },
        notifications: {
            created: 'Template created.',
            updated: 'Template updated.',
            deleted: 'Template deleted.'
        },
        errors: {
            loadStats: 'Unable to load warranty stats.',
            loadTemplates: 'Unable to load templates.',
            saveTemplate: 'Unable to save template.',
            deleteTemplate: 'Unable to delete template.',
            loadFormMeta: 'Unable to load form data.',
            loadActive: 'Unable to load active warranties.'
        },
        confirmDelete: 'Delete this template?'
    },
    DistributorDashboard: {
        title: 'Distributor Dashboard',
        loading: 'Loading distributor metrics...',
        error: 'Unable to load distributor dashboard.',
        metrics: {
            activeManufacturers: 'Active Manufacturers',
            activeRetailers: 'Active Retailers',
            activeVenues: 'Active Logistics Hubs',
            skuPortfolio: 'SKU Portfolio',
            inboundValue: 'Inbound Value',
            inboundQuantity: 'Inbound Quantity',
            outboundValue: 'Outbound Value',
            outboundQuantity: 'Outbound Quantity',
            inventoryOnHand: 'Inventory On Hand',
            orderFillRate: 'Order Fill Rate',
            averageFulfillmentTime: 'Avg. Fulfillment Time',
            returnsRate: 'Returns Rate',
            openSupportCases: 'Open Support Cases',
            integrationAlerts: 'Integration Alerts',
            campaignsSupported: 'Campaigns Supported'
        },
        insights: {
            topManufacturers: 'Top Manufacturers',
            topRetailers: 'Top Retailers',
            topRegions: 'Top Regions',
            actionItems: 'Action Items',
            noActions: 'No pending actions'
        },
        sections: {
            network: {
                title: 'Channel coverage',
                copy: 'How many partners, venues, and SKUs you actively touch today.'
            },
            flow: {
                title: 'Flow performance',
                copy: 'Track the movement of units across inbound and outbound lanes, along with fulfillment pace.'
            },
            health: {
                title: 'Reliability & engagement',
                copy: 'Quality signals such as returns, support workload, integration alerts, and joint campaigns.'
            }
        },
        inventory: {
            title: 'Warehouse capacity',
            copy: 'Aggregated stock across every distributor hub.',
            inboundQuantity: 'Inbound quantity',
            outboundQuantity: 'Outbound quantity'
        }
    }
    ,
    DistributorNav: {
        manufacturers: 'Manufacturers',
        retailers: 'Retailers'
    },
    DistributorVenues: {
        title: 'Distributor Venues',
        subtitle: 'Track downstream locations supplied by your network.',
        errors: {
            loadList: 'Unable to load venues.'
        },
        table: {
            search: 'Search venues...',
            view: 'Open',
            count: '{{count}} total',
            columns: {
                venue: 'Venue',
                retailer: 'Retailer',
                location: 'Location',
                outboundValue: 'Outbound value',
                lastActivity: 'Last activity',
                action: 'Action'
            }
        }
    },
    DistributorVenueDetail: {
        back: 'Back to Venues',
        subtitle: 'Performance overview for {{city}} hub',
        loading: 'Loading venue detail...',
        error: 'Unable to load venue detail.',
        stats: {
            outbound: 'Outbound value',
            units: 'units'
        },
        topItems: {
            title: 'Top items',
            empty: 'No items shipped yet.',
            metrics: '{{quantity}} units • {{value}}'
        }
    },
    Campaigns: {
        title: 'Kampagnen',
        name: 'Name',
        description: 'Beschreibung',
        startDate: 'Startdatum',
        endDate: 'Enddatum',
        goalDescription: 'Zielbeschreibung',
        budget: 'Budget',
        actions: 'Aktionen',
        edit: 'Bearbeiten',
        delete: 'Löschen',
        addNew: 'Neue Kampagne hinzufügen',
        search: 'Kampagnen suchen...',
        noCampaigns: 'Keine Kampagnen gefunden.',
        Tutorial: {
            welcomeMessage: 'Willkommen im Kampagnenmanagement!',
            createCampaignTitle: 'Neue Kampagne erstellen',
            createCampaignMessage: 'Hier können Sie eine neue Kampagne für Ihre Geschäftsanforderungen erstellen.',
            manageCampaignsTitle: 'Ihre Kampagnen verwalten',
            manageCampaignsMessage: 'Hier können Sie bestehende Kampagnen ansehen, bearbeiten und löschen. Nutzen Sie die Suche, um eine Kampagne schnell zu finden.',
            tutorialTitle: 'Kampagnen-Tutorial',
            tutorialMessage: 'Dieses Tutorial führt Sie durch die effektive Verwaltung von Kampagnen.'
        },
        CampaignCreate: {
            title: 'Neue Kampagne erstellen',
            name: 'Kampagnenname',
            description: 'Beschreibung',
            startDate: 'Startdatum',
            endDate: 'Enddatum',
            budget: 'Budget'
        }
    }
};
